var map = {
	"./CardData1.js": 3864,
	"./CardData10.js": 1818,
	"./CardData11.js": 4601,
	"./CardData12.js": 7200,
	"./CardData13.js": 3271,
	"./CardData14.js": 8390,
	"./CardData15.js": 7349,
	"./CardData16.js": 5772,
	"./CardData17.js": 1859,
	"./CardData18.js": 5986,
	"./CardData19.js": 3617,
	"./CardData2.js": 4001,
	"./CardData20.js": 9245,
	"./CardData21.js": 2974,
	"./CardData22.js": 651,
	"./CardData23.js": 4772,
	"./CardData24.js": 8641,
	"./CardData25.js": 8914,
	"./CardData26.js": 9823,
	"./CardData27.js": 8504,
	"./CardData28.js": 8261,
	"./CardData29.js": 6198,
	"./CardData3.js": 98,
	"./CardData30.js": 1080,
	"./CardData31.js": 5439,
	"./CardData32.js": 2834,
	"./CardData33.js": 721,
	"./CardData34.js": 7348,
	"./CardData35.js": 8795,
	"./CardData36.js": 7582,
	"./CardData37.js": 1933,
	"./CardData38.js": 4304,
	"./CardData39.js": 8455,
	"./CardData4.js": 6011,
	"./CardData5.js": 2660,
	"./CardData6.js": 429,
	"./CardData7.js": 862,
	"./CardData8.js": 4423,
	"./CardData9.js": 9296
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6764;